var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var ValidateError = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", width: "100%", height: "100%" }, props),
        React.createElement("circle", { id: "Oval", fill: color, cx: "13", cy: "13", r: "13" }),
        React.createElement("path", { fill: "#FFFFFF", fillRule: "nonzero", d: "M13.5138122,22 C14.9779006,22 16,20.8571429 16,19.5142857 C16,18.1714286 14.9779006,17 13.5138122,17 C12.0497238,17 11,18.1714286 11,19.5142857 C11,20.8571429 12.0497238,22 13.5138122,22 Z M11.670394,14.2857601 L11.1388319,6.13007782 C11.0669919,5.027847 11.9022887,4.07607454 13.0045195,4.00423454 C13.0478214,4.00141226 13.0912036,4 13.1345973,4 L13.8654027,4 C14.9699722,4 15.8654027,4.8954305 15.8654027,6 C15.8654027,6.04339373 15.8639904,6.08677597 15.8611681,6.13007782 L15.329606,14.2857601 C15.266758,15.2500274 14.4663132,16 13.5,16 C12.5336868,16 11.733242,15.2500274 11.670394,14.2857601 Z" })));
};
ValidateError.defaultProps = {
    color: '#E03636',
};
export default ValidateError;
//# sourceMappingURL=ValidateError.js.map